import { isInViewport } from "@roghz/isinviewport";
const fadeOptions = [{
  label: '------',
  value: ''
}, {
  label: 'Fade On',
  value: 'fade fade-on'
}, {
  label: 'Fade Up',
  value: 'fade fade-up'
}, {
  label: 'Fade Down',
  value: 'fade fade-down'
}, {
  label: 'Fade Left',
  value: 'fade fade-left'
}, {
  label: 'Fade Right',
  value: 'fade fade-right'
}, {
  label: 'Fade Scale',
  value: 'fade fade-scale'
}, {
  label: 'Rotate In',
  value: 'fade rotate-in'
}];

function fadeInAnimations() {
  let fadeElements = document.querySelectorAll('[data-fade]');

  const fadeIn = () => {
    for (let i = 0, len = fadeElements.length; i < len; i++) {
      if (isInViewport(fadeElements[i])) {
        fadeElements[i].classList.add('show');

        if ("delay" in fadeElements[i].dataset) {
          const dataDelay = fadeElements[i].dataset.delay;
          const delay = dataDelay * 200;
          fadeElements[i].style.transitionDelay = delay + 'ms';
        }
      }
    }
  };

  fadeIn();

  function debounce(callback, wait, immediate = false) {
    let timeout = null;
    return function () {
      const callNow = immediate && !timeout;

      const next = () => callback.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(next, wait);

      if (callNow) {
        next();
      }
    };
  }

  const handleScrollFade = debounce((arg, event) => {
    fadeIn();
  }, 50, true);
  window.addEventListener('scroll', event => {
    handleScrollFade();
  });
}

export { fadeInAnimations, fadeOptions };